import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { Formik, Field } from "formik";

import RowInput from "../../FormElements/RowInput";
import {
  financialValidationSchema,
  organizationValidationSchema,
} from "./functions";
import { OrganizationForm } from "./OrganizationForm";
import { Alerts } from "./Alerts";
import { ProjectUnitForm } from "./ProjectUnitForm";
import { ExternalProjectInfo } from "./ExternalProjectInfo";

const ProjectUnitModal = ({
  modalState,
  toggleModal,
  translate,
  defaultValues,
  organizationData,
  hasOrganization,
  setFiscalCode,
  errorOrganization,
  loadingOrganization,
  handleSubmit,
  unitsByOrganizationCount,
  unitsByOrganization,
  openOrganizationUpdateModal,
}) => {
  const [validationSchema, setValidationSchema] = useState(
    organizationValidationSchema
  );
  const existingOrganization = organizationData?.result;

  useEffect(() => {
    setValidationSchema(organizationValidationSchema);
    if (organizationData?.result) {
      setValidationSchema(financialValidationSchema);
    } else {
      setValidationSchema(organizationValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationData, errorOrganization]);

  return (
    <Modal isOpen={modalState} toggle={() => toggleModal(false)}>
      <ModalHeader>
        {loadingOrganization && <Spinner className="me-2"></Spinner>}
        {translate("manageProjectUnit")}
      </ModalHeader>
      {defaultValues && (
        <Formik
          initialValues={defaultValues}
          onSubmit={(values) => handleSubmit(values, existingOrganization)}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ handleSubmit, values }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <Field
                  disabled
                  label={translate("project")}
                  name={"project.code"}
                  component={RowInput}
                />
                <Field
                  label={translate("fiscalCode")}
                  name="organization.fiscalCode"
                  disabled={
                    defaultValues &&
                    (defaultValues.isDisabled ||
                      (defaultValues.organization &&
                        defaultValues.organization.fiscalCode))
                  }
                  customOnBlur={(e) => setFiscalCode(e.target.value)}
                  component={RowInput}
                />

                <Alerts
                  translate={translate}
                  existingOrganization={existingOrganization}
                  defaultValues={defaultValues}
                  hasOrganization={hasOrganization}
                />
                {unitsByOrganization?.length > 0 && (
                  <ExternalProjectInfo
                    translate={translate}
                    unitsByOrganizationCount={unitsByOrganizationCount}
                    unitsByOrganization={unitsByOrganization}
                    openOrganizationUpdateModal={openOrganizationUpdateModal}
                  />
                )}

                {!existingOrganization?.id && (
                  <OrganizationForm
                    organizationData={organizationData?.result}
                    translate={translate}
                    defaultValues={defaultValues}
                    fiscalCode={values?.organization?.fiscalCode}
                  />
                )}

                {existingOrganization?.id &&
                  (!hasOrganization || defaultValues.organization?.id) && (
                    <ProjectUnitForm
                      defaultValues={defaultValues}
                      translate={translate}
                    />
                  )}
              </ModalBody>
              <ModalFooter>
                {!defaultValues.isDisabled && (
                  <Button type="submit">
                    {!existingOrganization
                      ? translate("submitOrganization")
                      : translate("submitProjectUnit")}
                  </Button>
                )}
              </ModalFooter>
            </form>
          )}
        </Formik>
      )}
    </Modal>
  );
};
export default ProjectUnitModal;
